// Mirrors apps/api/src/api/http/routers/register.py response models.

export interface AdvisorSignal {
  id: string;
  signal_kind: string;
  source_advisor: string;
  candidate_path: string;
  proposed_project_type_code: string;
  proposed_lifecycle_stage_code: string;
  confidence: number;
  rationale: Record<string, unknown>;
  status: "proposed" | "applied" | "declined" | "superseded" | string;
  created_at: string;
  applied_at: string | null;
  resulting_project_id: string | null;
}

export interface AdvisorSignalListResponse {
  advisor_signals: AdvisorSignal[];
}

export interface ExcelImportStartRequest {
  source_file_name: string;
  source_file_hash: string;
  column_mapping: Record<string, string>;
}

export interface ExcelImportStartResponse {
  import_run_id: string;
  accepted_at: string;
}

export interface SignalApplyResponse {
  signal_id: string;
  resulting_project_id: string;
  applied_at: string;
}

export interface ExcelImportRunDetailResponse {
  id: string;
  source_file_name: string;
  source_file_hash: string;
  approved_by_actor_id: string;
  approved_at: string;
  executed_at: string;
  row_counts: Record<string, number>;
  column_mapping: Record<string, string>;
  resulting_project_ids: string[];
}

// Canonical register fields (see packages/ai/src/ai/excel_mapping/ports.py).
export const CANONICAL_FIELDS = [
  "display_reference",
  "project_type_code",
  "lifecycle_stage_code",
  "counterparty",
] as const;

export type CanonicalField = (typeof CANONICAL_FIELDS)[number];

// -- Recurring file-source watcher (POST /register/file-sources/*) ----------

export interface RegisterFileSourcePreviewRequest {
  share_path: string;
  file_name: string;
}

export interface RegisterFileSourcePreviewResponse {
  content_sha256: string;
  sheet_name: string;
  headers: string[];
}

export interface RegisterFileSourceCreateRequest {
  share_path: string;
  file_name: string;
  column_mapping: Record<string, string>;
}

export interface RegisterFileSourceCreateResponse {
  source_id: string;
  initial_import_run_id: string | null;
  accepted_at: string;
}

export interface RegisterFileSourceItem {
  id: string;
  share_path: string;
  file_name: string;
  column_mapping: Record<string, string>;
  last_known_hash: string | null;
  last_scanned_at: string | null;
  last_import_run_id: string | null;
  status: "active" | "paused" | "removed" | string;
  created_by_actor_id: string;
  created_at: string;
  updated_at: string;
}

export interface RegisterFileSourceListResponse {
  file_sources: RegisterFileSourceItem[];
}

// -- One-shot upload (POST /register/file-sources/*-upload) -----------------

export interface RegisterFileSourceUploadPreviewResponse {
  content_sha256: string;
  sheet_name: string;
  headers: string[];
  file_name: string;
}

export interface RegisterFileSourceUploadImportResponse {
  import_run_id: string;
  content_sha256: string;
  sheet_name: string;
  row_counts: Record<string, number>;
  accepted_at: string;
}
